/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import Spell from './Spell';
import AttributeValues from "./AttributeValues";

class NpcData {
    name:                                      string     = "";
    raceName:                                  string     = "";
    primaryClassName:                          string     = "";
    primaryArchetypeName:                      string     = "";
    secondaryClassName:                        string     = "";
    secondaryArchetypeName:                    string     = "";
    backgroundName:                            string     = "";
    primaryLevel:                              number     = 0;
    secondaryLevel:                            number     = 0;
    attributeBases:                            number[]   =[];
    diceArray:                                 string     = "";
    attributeValues:                           AttributeValues = new AttributeValues();
    asiRacialSelected:                         string[]   = [];
    asiClassSelected:                          string[]   = [];
    raceOptions:                               string     = "";
    primaryClassOptions:                       string     = "";
    secondaryClassOptions:                     string     = "";
    langsRaceSelected:                         string[]   = [];
    langsClassSelected:                        string[]   = [];
    langsBackgroundSelected:                   string[]   = [];
    skillsRaceSelected:                        string[]   = [];
    skillsClassSelected:                       string[]   = [];
    skillsBackgroundSelected:                  string[]   = [];
    spellbookSpellsArrayBySpellLevelPrimary:   Spell[][]  = [];
    spellbookSpellsArrayBySpellLevelSecondary: Spell[][]  = [];
    spellsPreparedArrayBySpellLevelPrimary:    Spell[][]  = [];
    spellsPreparedArrayBySpellLevelSecondary:  Spell[][]  = [];
    spellbookSpellSlugsBySpellLevelPrimary:    string[]  = [];
    spellbookSpellSlugsBySpellLevelSecondary:  string[]  = [];
    spellSlugsPreparedBySpellLevelPrimary:     string[]  = [];
    spellSlugsPreparedBySpellLevelSecondary:   string[]  = [];

    static getSlugsFromSpells = (spellsBySpellLevel: Spell[][] | null): string[] => {
        const slugs: string[] = [];
        for (const level of spellsBySpellLevel?.keys() || []) {
            const levelSpells:Spell[] = spellsBySpellLevel?.[level] || [];
            slugs[level] = levelSpells.map(spell => spell.slug).join(',');
        }
        return slugs;
    }
    static getSpellsFromSlugs = (spellSlugsBySpellLevel: string[] | null, slugsToSpellMap: Map<string, Spell>): Spell[][] => {
        const spells: Spell[][] = [];
        for (const level of spellSlugsBySpellLevel?.keys() || []) {
            spells[level] = [];
            const levelSlugs:string = spellSlugsBySpellLevel?.[level] || '';
            for (const slug of levelSlugs.split(',')) {
                const spell = slugsToSpellMap.get(slug);
                if (spell) {
                    spells[level].push(spell);
                }
            }
        }
        return spells;
    }
    static updateSpellsFromSlugs = (npcData: NpcData, slugsToSpellMap: Map<string, Spell>) => {
        npcData.spellbookSpellsArrayBySpellLevelPrimary   = NpcData.getSpellsFromSlugs(npcData.spellbookSpellSlugsBySpellLevelPrimary,   slugsToSpellMap);
        npcData.spellbookSpellsArrayBySpellLevelSecondary = NpcData.getSpellsFromSlugs(npcData.spellbookSpellSlugsBySpellLevelSecondary, slugsToSpellMap);
        npcData.spellsPreparedArrayBySpellLevelPrimary    = NpcData.getSpellsFromSlugs(npcData.spellSlugsPreparedBySpellLevelPrimary,    slugsToSpellMap);
        npcData.spellsPreparedArrayBySpellLevelSecondary  = NpcData.getSpellsFromSlugs(npcData.spellSlugsPreparedBySpellLevelSecondary,  slugsToSpellMap);    
    }
}
export default NpcData;